// @flow
import React, { Component } from 'react'
import Background from 'client/components/background'
import { Outlet } from 'react-router-dom'
// $FlowFixMe
class Container extends Component {
  render (): any {
    const { auth, client } = this.props
    const year = new Date().getFullYear()

    return (
      <div className='login-layout'>
        <Background />
        <div className='login-layout__panel'>
          <div className='login-layout__card'>
            {auth && client && <Outlet context={{ auth, client }} />}
          </div>
          <footer className='login-layout__footer'>
            <span>&copy;{year} WINMORE. All rights reserved.</span>
            <span className='login-layout__footer-sep'>&middot;</span>
            <a className='login-layout__footer-link' href='https://winmore.io'>winmore.io</a>
          </footer>
        </div>
      </div>
    )
  }
}

export default Container
